import React from "react";
import { motion } from "framer-motion";
import { BanIcon, ClockIcon, MoonIcon, FrownIcon } from "lucide-react";
const nodes = [{
  label: "Restricción",
  sub: "Comes una manzana",
  icon: BanIcon,
  pos: "left-1/2 top-0 -translate-x-1/2 -translate-y-1/2"
}, {
  label: "Ansia",
  sub: "4:00 PM",
  icon: ClockIcon,
  pos: "right-0 top-1/2 translate-x-1/3 -translate-y-1/2"
}, {
  label: "Atracón",
  sub: "8:00 PM, escondida",
  icon: MoonIcon,
  pos: "left-1/2 bottom-0 -translate-x-1/2 translate-y-1/2"
}, {
  label: "Culpa",
  sub: "\"Mañana empiezo\"",
  icon: FrownIcon,
  pos: "left-0 top-1/2 -translate-x-1/3 -translate-y-1/2"
}];
export function CycleDiagram() {
  return <div className="relative mx-auto aspect-square w-full max-w-[340px] sm:max-w-[380px]" data-id="element-132" data-mp="3gr7t7ke76ton">
      <motion.svg viewBox="0 0 200 200" className="absolute inset-0 h-full w-full" animate={{
      rotate: 360
    }} transition={{
      duration: 40,
      repeat: Infinity,
      ease: "linear"
    }} aria-hidden data-id="element-133" data-mp="3bwlh1f0akx3i">
        <circle cx="100" cy="100" r="88" fill="none" stroke="#E4B9AB" strokeWidth="2" strokeDasharray="6 6" data-id="element-134" data-mp="297ekjxnghxkb" />
        {[45, 135, 225, 315].map(deg => <g key={deg} transform={`rotate(${deg} 100 100)`} data-id="element-135" data-mp="2d6dmd9dw5e7j">
            <path d="M100 8 l6 4 -6 4" fill="none" stroke="#C7254E" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-136" data-mp="2i082k2uafb1v" />
          </g>)}
      </motion.svg>
      <div className="absolute inset-[22%] flex flex-col items-center justify-center rounded-full bg-cocoa text-center text-cream shadow-xl" data-id="element-137" data-mp="1q8agz4eoow01">
        <p className="font-display text-xl font-bold leading-tight sm:text-2xl" data-id="element-138" data-mp="1ua4beuyad3rr">El ciclo</p>
        <p className="mt-1 px-4 text-xs text-cream/70" data-id="element-139" data-mp="1z7xhzp3i3zsk">restricción · culpa · ansia</p>
      </div>
      {nodes.map(({
      label,
      sub,
      icon: Icon,
      pos
    }, i) => <motion.div key={label} className={`absolute ${pos} w-32 rounded-2xl bg-white p-3 text-center shadow-[0_12px_30px_-12px_rgba(59,34,25,0.4)]`} initial={{
      opacity: 0,
      scale: 0.96
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.3,
      delay: 0.1 + i * 0.12
    }} data-id="element-140" data-mp="3ao47tvxxaba9" data-mpi={i}>
          <Icon className="mx-auto h-5 w-5 text-berry" data-id="element-141" data-mp="2l22u9au4hju4" />
          <p className="mt-1 text-sm font-bold text-cocoa" data-id="element-142" data-mp="2zvo82eudmbsr">{label}</p>
          <p className="text-[11px] text-cocoa-light" data-id="element-143" data-mp="2uxcym57zu3b2">{sub}</p>
        </motion.div>)}
    </div>;
}